import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRICING } from "@/data/landingData";
import { PriceCalculator } from "./PriceCalculator";

export const Pricing = ({ onTrial }) => {
  return (
    <section id="harga" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-400">Harga Transparan</span>
          <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Investasi Terjangkau untuk Sekolah Modern
          </h2>
          <p className="mt-4 text-base text-slate-300">
            Pilih paket sesuai jumlah siswa. Semua paket termasuk subdomain khusus & backup otomatis harian.
          </p>
        </div>

        <PriceCalculator />

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {PRICING.map((p, i) => (
            <motion.div
              key={p.id}
              data-testid={`pricing-${p.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              className={`relative flex flex-col rounded-2xl border p-7 ${
                p.popular
                  ? "border-cyan-400/50 bg-gradient-to-b from-cyan-950/40 to-[#0D1424] shadow-[0_0_35px_rgba(0,240,255,0.15)]"
                  : "border-cyan-500/15 bg-[#0D1424]"
              }`}
            >
              {p.popular && (
                <div className="absolute -top-3 left-1/2 flex -translate-x-1/2 items-center gap-1 rounded-full bg-gradient-to-r from-cyan-400 to-violet-600 px-4 py-1 text-xs font-semibold text-[#060A12]">
                  <Star className="h-3.5 w-3.5 fill-current" /> Paling Populer
                </div>
              )}
              <h3 className="font-heading text-lg font-bold text-white">{p.name}</h3>
              <p className="mt-1 text-sm text-slate-400">{p.capacity}</p>
              <div className="mt-5">
                <span className="font-heading text-3xl font-bold text-white">{p.priceRange}</span>
                <span className="text-sm text-slate-400">{p.period}</span>
              </div>
              <p className="mt-3 text-xs text-cyan-400/80">Ideal untuk: {p.recommendedFor}</p>

              <ul className="mt-6 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-slate-300">
                    <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-400" />
                    {f}
                  </li>
                ))}
              </ul>

              <Button
                onClick={() => onTrial(p.name)}
                data-testid={`pricing-cta-${p.id}`}
                className={`mt-7 h-11 w-full font-semibold ${
                  p.popular
                    ? "bg-gradient-to-r from-cyan-400 to-violet-600 text-[#060A12] hover:shadow-[0_0_20px_rgba(0,240,255,0.4)]"
                    : "border border-cyan-500/30 bg-transparent text-white hover:bg-cyan-500/10"
                }`}
              >
                Mulai Uji Coba
              </Button>
            </motion.div>
          ))}
        </div>

        <div className="mx-auto mt-10 max-w-3xl rounded-xl border border-violet-500/20 bg-violet-950/20 p-5 text-center">
          <p className="text-sm text-slate-300">
            <span className="font-semibold text-violet-300">Biaya Setup & Onboarding Awal:</span>{" "}
            Rp 500.000 – Rp 1.500.000 (satu kali) — mencakup migrasi data Excel/Dapodik, konfigurasi subdomain, dan pelatihan operator & guru.
          </p>
        </div>
      </div>
    </section>
  );
};
